import { Pagination } from "./Pagination"

export class SubDistrict {
  public subDistrict?: string

  constructor(subDistrict?: string) {
    this.subDistrict = subDistrict
  }
}

export class Village {
  public village?: string

  constructor(village?: string) {
    this.village = village
  }
}

export class ReschedulePickups {
  public data?: ReschedulePickup[]
  public pagination?: Pagination

  constructor(
    data?: ReschedulePickup[],
    pagination?: Pagination
  ) {
    this.data = data
    this.pagination = pagination
  }
}

export class ReschedulePickup {
  public shipmentId?: string
  public groupId?: string
  public customerName?: string
  public customerPhoneNumber?: string
  public statuses?: string[]
  public rescheduleType?: string
  public courier?: ReschedulePickupCourier
  public rescheduledAt?: string
  public customerAddress?: string
  public createdAt?: string
  public duration?: string
  public statusApproval?: string
  public isPriority?: boolean
  public pickupBoosterAmount?: number
  public longitude?: number
  public latitude?: number
  public clientId?: string
  public clientName?: string
  public totalShipment?: number
  public totalQuantity?: number
  public shipmentType?: string

  constructor(
    shipmentId?: string,
    groupId?: string,
    customerName?: string,
    customerPhoneNumber?: string,
    statuses?: string[],
    rescheduleType?: string,
    courier?: ReschedulePickupCourier,
    rescheduledAt?: string,
    customerAddress?: string,
    createdAt?: string,
    duration?: string,
    statusApproval?: string,
    isPriority?: boolean,
    pickupBoosterAmount?: number,
    longitude?: number,
    latitude?: number,
    clientId?: string,
    clientName?: string,
    totalShipment?: number,
    totalQuantity?: number,
    shipmentType?: string
  ) {
    this.shipmentId = shipmentId
    this.groupId = groupId
    this.customerName = customerName
    this.customerPhoneNumber = customerPhoneNumber
    this.statuses = statuses
    this.rescheduleType = rescheduleType
    this.courier = courier
    this.rescheduledAt = rescheduledAt
    this.customerAddress = customerAddress
    this.createdAt = createdAt
    this.duration = duration
    this.statusApproval = statusApproval
    this.isPriority = isPriority
    this.pickupBoosterAmount = pickupBoosterAmount
    this.longitude = longitude
    this.latitude = latitude
    this.clientId = clientId
    this.clientName = clientName
    this.totalShipment = totalShipment
    this.totalQuantity = totalQuantity
    this.shipmentType = shipmentType
  }
}

export class ReschedulePickupCourier {
  public courierId?: number
  public fullname?: string
  public courierType?: string
  public phoneNumber?: string
  public latitude?: number
  public longitude?: number
  public distance?: number

  constructor(
    courierId?: number,
    fullname?: string,
    courierType?: string,
    phoneNumber?: string,
    latitude?: number,
    longitude?: number,
    distance?: number
  ) {
    this.courierId = courierId
    this.fullname = fullname
    this.courierType = courierType
    this.phoneNumber = phoneNumber
    this.latitude = latitude
    this.longitude = longitude
    this.distance = distance
  }
}

export class ReschedulePickupCourierV2 {
  courierName = "";
  courierReason = "";
  courierRequestedAt = "";

  constructor(fields?: Partial<ReschedulePickupCourierV2>) {
    Object.assign(this, fields);
  }
}

export class ReschedulePickupDetail {
  public shipmentId?: string
  public groupId?: string
  public customerName?: string
  public customerPhoneNumber?: string
  public customerAddress?: string
  public latitude?: number
  public longitude?: number
  public rescheduledAt?: string
  public createdAt?: string
  public statusApproval?: string
  public lastReason?: string
  public meta?: Record<string, string[]>
  public assignCourier?: ReschedulePickupCourier | null
  public lastCourier?: ReschedulePickupCourier
  public isPriority?: boolean
  public pickupBoosterAmount?: number

  constructor(
    shipmentId?: string,
    groupId?: string,
    customerName?: string,
    customerPhoneNumber?: string,
    customerAddress?: string,
    latitude?: number,
    longitude?: number,
    rescheduledAt?: string,
    createdAt?: string,
    statusApproval?: string,
    lastReason?: string,
    meta?: Record<string, string[]>,
    assignCourier?: ReschedulePickupCourier | null,
    lastCourier?: ReschedulePickupCourier,
    isPriority?: boolean,
    pickupBoosterAmount?: number

    ) {
    this.shipmentId = shipmentId
    this.groupId = groupId
    this.customerName = customerName
    this.customerPhoneNumber = customerPhoneNumber
    this.customerAddress = customerAddress
    this.latitude = latitude
    this.longitude = longitude
    this.rescheduledAt = rescheduledAt
    this.createdAt = createdAt
    this.statusApproval = statusApproval
    this.meta = meta
    this.assignCourier = assignCourier
    this.lastCourier = lastCourier
    this.lastReason = lastReason
    this.isPriority = isPriority
    this.pickupBoosterAmount = pickupBoosterAmount
  }
}

export class ReschedulePickupDetailV2 {
  shipperHash = null
  senderName = ""
  senderPhone = ""
  senderAddress = ""
  courierName = ""
  courierPhone = ""
  courierReason = ""
  courierRequestedAt = ""
  statusApproval = ""
  approvedBy = ""
  approvedAt = "" as unknown
  rejectionReason = ""
  rejectedBy = ""
  rejectedAt = ""
  nextCourierId = 0
  nextCourierName = ""
  nextPickupDate = ""
  nextPickupTime = ""
  nextCourierAgentCode = ""
  nextCourierAgentName = ""
  nextCourierType = ""
  rescheduledType = ""
  latitude = 0
  longitude = 0
  courierAgentCode = ""
  courierAgentName = ""
  courierId = 0
  courierType = ""
  shipmentId = ""
  shipments = [] as ReschedulePickupDetailVShipment[]
  pagination = new Pagination()
  proofUrls = []

  constructor(fields?: Partial<ReschedulePickupDetailV2>) {
    Object.assign(this, fields);
  }
}

export class ReschedulePickupDetailVShipment {
  shipmentId = "";
  orderId = "";
  productType = "";
  totalColly = 0;
  status = "";

  constructor(fields?: Partial<ReschedulePickupDetailVShipment>) {
    Object.assign(this, fields);
  }
}
